import { Country } from 'modules/legal_entities/lib/constants'

import { FranceIdType } from './france/idType'
import { GermanyIdType } from './germany/idType'
import { ItalyIdType } from './italy/idType'
import { PortugalIdType } from './portugal/idType'
import { SpainIdType } from './spain/idType'

const getMaxLengthByCountryAndIdType = (
  country: Country,
  idType: SpainIdType | GermanyIdType | FranceIdType | ItalyIdType | PortugalIdType
) => {
  const maxLength: Record<Country, Record<string, number>> = {
    [Country.Spain]: {
      [SpainIdType.DNI]: 9,
      [SpainIdType.NIE]: 9,
      [SpainIdType.PASSPORT]: 9,
      [SpainIdType.SOCIAL_SECURITY_NUMBER]: 12,
    },
    [Country.France]: {
      [FranceIdType.NTT]: 40,
      [FranceIdType.NIA]: 10,
      [FranceIdType.PASSPORT]: 9,
      [FranceIdType.NIR]: 16,
    },
    [Country.Germany]: {
      [GermanyIdType.Steueridentifikationsnummer]: 11,
      [GermanyIdType.Reisepass]: 9,
      [GermanyIdType.Sozialversicherungsnummer]: 12,
      [GermanyIdType.Personalausweis]: 11,
    },
    [Country.Italy]: {
      [ItalyIdType.CODICE_FISCALE]: 16,
      [ItalyIdType.PERMESSO_DI_SOGGIORNO]: 9,
      [ItalyIdType.PASSPORT]: 9,
      [ItalyIdType.CARTA_D_IDENTITA]: 9,
    },
    [Country.Portugal]: {
      [PortugalIdType.TaxId]: 9,
      [PortugalIdType.Passport]: 9,
      [PortugalIdType.SocialSecurityNumber]: 11,
      [PortugalIdType.IdCard]: 15,
      [PortugalIdType.ResidenceCard]: 9,
    },
    // Add more countries and id_types below
  }

  const countryMaxLengths = maxLength[country]

  if (!countryMaxLengths || !countryMaxLengths[idType]) {
    return undefined // Return undefined if country or idType is not listed
  }

  return countryMaxLengths[idType]
}

export default getMaxLengthByCountryAndIdType
